import { useEffect, useState } from 'react'

import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../../constants/common'
import { useIsProfileWidgetsExpandAvailable } from '../useIsProfileWidgetsExpandAvailable'
import { useProfileWidgetsExpandContext } from '../useProfileWidgetsExpandContext'

export function useWidgetExpandedState({
  initiallyExpanded,
  isFollowingWidgetsExpand,
}) {
  const {
    expandCommand: widgetsExpandCommand = null,
    handleCountedWidgetToggle = EMPTY_FUNCTION,
    registerCountedWidget = EMPTY_FUNCTION,
  } = useProfileWidgetsExpandContext() ?? EMPTY_OBJECT

  const isWidgetsExpandAvailable = useIsProfileWidgetsExpandAvailable()

  const expandCommand = isFollowingWidgetsExpand ? widgetsExpandCommand : null

  const [isExpanded, setExpanded] = useState(
    expandCommand?.isExpanded ?? initiallyExpanded
  )
  const [appliedExpandCommand, setAppliedExpandCommand] =
    useState(widgetsExpandCommand)
  const [expandButtonsCount, setExpandButtonsCount] = useState(0)

  if (appliedExpandCommand !== widgetsExpandCommand) {
    setAppliedExpandCommand(widgetsExpandCommand)
    setExpanded(expandCommand?.isExpanded ?? isExpanded)
  }

  const isCountedByWidgetsExpand =
    isFollowingWidgetsExpand && expandButtonsCount > 0

  function registerExpandButton() {
    if (isWidgetsExpandAvailable) {
      setExpandButtonsCount(count => count + 1)

      return () => {
        setExpandButtonsCount(count => count - 1)
      }
    }
  }

  function handleExpandedChangeByUser(nextIsExpanded) {
    setExpanded(nextIsExpanded)

    if (isCountedByWidgetsExpand) {
      handleCountedWidgetToggle({ isExpanded: nextIsExpanded })
    }
  }

  useEffect(() => {
    if (isCountedByWidgetsExpand) {
      return registerCountedWidget({ isExpanded })
    }
  }, [isCountedByWidgetsExpand, isExpanded])

  return { handleExpandedChangeByUser, isExpanded, registerExpandButton }
}
